module.exports = __webpack_public_path__ + "static/img/title-banner1-type1.c070ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/8/title-banner1-type1.png
// module id = Egjv
// module chunks = 1